const tr = {
  localUsers: {
    title: 'Kullanıcılar',
    desc: 'Entra dışındaki kullanıcılar için parola ile giriş hesapları. Kurum dizinindeki herkes zaten Microsoft ile girer; bu bölüm yalnızca dizinde olmayan kişiler içindir.',
    name: 'Ad Soyad',
    role: 'Rol',
    roleLegalAnalyst: 'Hukuk Analisti',
    roleReviewer: 'İnceleyici',
    roleFirmAdmin: 'Büro Yöneticisi',
    roleStatsAdmin: 'İstatistik Yöneticisi',
    roleAdmin: 'Yönetici',
    roleChanged: '{email} artık {role}.',
    firmAdminNeedsFirm: '{email} artık Büro Yöneticisi, ancak büro kimliği boş olduğu için hiçbir kullanıcıyı göremez. Büro kimliğini girin.',
    firmAdminNeedsFirmShort: 'Büro kimliği boş: bu rol hiçbir kullanıcıyı göremez.',
    firmPrompt: '{email} için büro kimliği:',
    firmChanged: '{email} için büro kimliği güncellendi.',
    firmId: 'Büro kimliği',
    firmHint: 'Büro kimliği, "Büro Yöneticisi" rolünün hangi kullanıcıları görebileceğini belirler. Boş bırakılırsa o rol hiçbir kullanıcıyı göremez.',
    create: 'Oluştur',
    existing: 'Mevcut hesaplar',
    none: 'Henüz parola ile giriş hesabı yok.',
    status: 'Durum',
    active: 'Aktif',
    disabled: 'Devre dışı',
    pendingChange: 'ilk girişte parola değişecek',
    reset: 'Parola sıfırla',
    disable: 'Devre dışı bırak',
    enable: 'Etkinleştir',
    remove: 'Sil',
    confirmRemove: '{email} hesabını kalıcı olarak silmek istiyor musunuz? Bu işlem geri alınamaz. Kişi işten ayrılmadıysa "Devre dışı bırak" daha güvenlidir; hesabı geri açabilirsiniz.',
    removed: 'Hesap silindi.',
    copyPassword: 'Parolayı kopyala',
    sendLink: 'Giriş bağlantısı gönder',
    sendLinkAll: 'Tüm aktif kullanıcılara giriş bağlantısı gönder',
    confirmSendAll: 'Tüm aktif kullanıcılara giriş bağlantısı e-postası gönderilecek. Onaylıyor musunuz?',
    linkSentTo: 'Giriş bağlantısı gönderildi: {email}',
    bulkResult: '{sent} kullanıcıya gönderildi, {failed} başarısız. Gönderen: {from}',
    onceOnly: 'Bu parola yalnızca bir kez gösterilir. Güvendiğiniz bir kanaldan iletin; kullanıcı ilk girişte değiştirmek zorundadır.',
    hide: 'Gizle',
  },
  budget: {
    tokenUnit: 'token',
    tooltip: 'Bu ay {used} / {limit} USD kullanıldı · {tokens} token harcandı. Başlıktaki sayı 100 tokenlik birim cinsindendir.',
    title: 'Kullanım ve Bütçe',
    perUser: 'Kullanıcı bazında tahmini kullanım',
    eachUser: 'kullanıcı',
    azureSpend: 'Azure gerçek harcama (ay başından bu yana)',
    estimateNote: 'Soldaki tutar token sayımından hesaplanan TAHMİNDİR; sağdaki Azure faturasından gelir. İkisi birebir aynı olmaz.',
    limit: 'Aylık limit',
    used: 'Kullanılan',
    tokens: 'Token',
    realTokens: 'Gerçek token sayısı',
    effectiveRate: 'Fiili birim maliyet',
    byModel: 'Modele göre',
    partialNote: 'Bu satırın bir kısmı model bazında token kaydı başlamadan önce oluştu; token sayısı eksiktir.',
    calls: 'Çağrı',
    refresh: 'Yenile',
    stale: 'Önbellekten (Azure istek sınırı)',
    notConfigured: 'Azure abonelik kimliği ayarlanmadı.',
    loading: 'Yükleniyor…',
    unknown: 'Bilinmiyor',
  },
  effort: {
    label: 'Çalışma modu',
    presets: 'Mod',
    models: 'Model',
    modelAuto: 'Otomatik',
    quick: 'Hızlı',
    thinking: 'Düşünen',
    quickHint: 'Daha hızlı; kıdemli ortak denetimi atlanır.',
    thinkingHint: 'Daha yavaş; kıdemli ortak denetimi de çalışır.',
    quickDiffHint: 'Daha hızlı; farklar listelenir, madde madde yapay zekâ yorumu yapılmaz.',
    thinkingDiffHint: 'Daha yavaş; değişen her madde için yapay zekâ etki yorumu üretilir.',
    quickChatHint: 'Daha hızlı yanıt.',
    thinkingChatHint: 'Daha derin akıl yürütme; yanıt daha uzun sürer.',
  },
  sources: {
    pick: 'Kaynak ekle',
    localFile: 'Bilgisayardan dosya yükle',
    myFolders: 'Kaynak klasörlerim',
    none: 'Henüz kaynak klasörü yok. Ayarlar › Kaynak Klasörleri bölümünden ekleyin.',
    remove: 'Kaynağı kaldır',
    title: 'Kaynak Klasörleri',
    desc: 'Yapay zekânın hangi belgelere bakacağını siz seçin. Bir klasör belgelerin kendisini değil, bağlantısını tutar; erişim her okumada yeniden denetlenir.',
    newFolder: 'Yeni klasör',
    name: 'Klasör adı',
    visibility: 'Görünürlük',
    private: 'Yalnızca ben',
    firm: 'Büro geneli',
    items: 'öğe',
    empty: 'Bu klasör boş.',
    save: 'Kaydet',
    delete: 'Sil',
    confirmDelete: 'Bu klasör silinsin mi?',
    localHint: 'Tarayıcıdan klasör seçimi yalnızca Chrome ve Edge’de çalışır ve her oturumda yeniden izin ister.',
    pickLocal: 'Bilgisayardan klasör seç',
    ownerOnly: 'Bu klasörü yalnızca sahibi değiştirebilir.',
  },
  talent: {
    pick: 'Yetenek seç',
    clear: 'Yeteneği kaldır',
    analyze: 'Doküman Analizi',
    compare: 'Doküman Karşılaştırma',
    draft: 'Belge Oluştur',
    caseDocs: 'Dosya Belgelerimde Ara',
    caselaw: 'İçtihat Ara',
    mevzuat: 'Mevzuat / Kanun Görüntüle',
    articles: 'Madde Karşılaştır',
    calculate: 'Hesaplama',
    web: 'Web’de Ara',
  },
  appName: 'B-Agent Law',
  nav: {
    dashboard: 'Panel',
    contractAnalysis: 'Doküman Analizi',
    legislationDiff: 'Doküman Karşılaştırma',
    caseLaw: 'İçtihat / Emsal',
    ministry: 'Bakanlık Kararları',
    generator: 'Doküman Üretici',
    converter: 'Biçim Dönüştürücü',
    hesaplama: 'Hesaplamalar',
    caseFiles: 'Dosyalarım (UYAP)',
    chat: 'Sohbet',
    activity: 'Aktivite',
    admin: 'Yönetim',
    settings: 'Ayarlar',
    mainNav: 'Ana menü',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
  },
  auth: {
    or: 'veya',
    email: 'E-posta',
    password: 'Parola',
    currentPassword: 'Mevcut parola',
    newPassword: 'Yeni parola (en az 12 karakter)',
    signingIn: 'Giriş yapılıyor…',
    signInFailed: 'Giriş yapılamadı.',
    setPasswordAndSignIn: 'Parolayı belirle ve gir',
    mustChangePassword: 'İlk girişte parolanızı değiştirmeniz gerekiyor.',
    rememberMe: 'Beni hatırla',
    rememberMeHint: 'E-posta adresiniz bu cihazda hatırlanır ve oturumunuz daha uzun sürer. Güvenlik gereği 30 dakika hareketsizlik sonrası parola yine sorulur.',
    emailLinkButton: 'E-posta ile giriş bağlantısı gönder',
    emailLinkHint: 'Parolanızı bilmiyorsanız, adresinize tek kullanımlık bir giriş bağlantısı gönderelim.',
    emailLinkSent: 'Bu adrese ait bir hesap varsa giriş bağlantısı gönderildi.',
    emailLinkSigningIn: 'Giriş bağlantısı doğrulanıyor…',
    emailRequired: 'Önce e-posta adresinizi yazın.',
    forgotPassword: 'Şifremi unuttum',
    forgotPasswordHint: 'E-posta adresinize tek kullanımlık bir giriş bağlantısı gönderelim; girdikten sonra yeni bir parola belirleyebilirsiniz.',
    linkSignedInAs: 'Giriş bağlantısı doğrulandı:',
    setPasswordAndContinue: 'Parolayı belirle ve devam et',
    continueWithoutPassword: 'Parola belirlemeden devam et',
    signIn: 'Giriş yap',
    logOut: 'Çıkış',
    loginSubtitle: 'Devam etmek için rol seçin',
    role: 'Rol',
    bothSubtitle: 'Microsoft hesabınızla veya e-posta ve parolanızla oturum açın',
    entraSubtitleMicrosoft: 'Microsoft hesabınızla oturum açın',
    signInMicrosoft: 'Microsoft ile oturum aç',
    entraFailed:
      'Microsoft ile oturum açılamadı. Normal tarayıcıda uygulama tam sayfa yönlendirme kullanır (Entra’da bu sitenin tam adresinin yönlendirme URI’si olarak kayıtlı olduğundan emin olun). Teams veya gömülü pencerede açılır pencerelere izin verin. Sorun sürerse yönetici, uygulama kaydını doğrulasın: yönlendirme URI, API izinleri ve yönetici onayı.',
    sessionExpired: 'Oturum süreniz doldu. Güvenliğiniz için çıkış yapıldı; lütfen tekrar giriş yapın.',
    sessionIdle: 'Uzun süre işlem yapılmadığı için oturumunuz kapatıldı. Lütfen tekrar giriş yapın.',
    idleWarning: 'İşlem yapılmadığı için {seconds} saniye içinde oturumunuz kapatılacak.',
    staySignedIn: 'Oturumu sürdür',
  },
  dashboard: {
    title: 'Panel',
    desc: 'Başlamak için bir akış seçin.',
    contractCardTitle: 'Doküman Analizi',
    contractCardDesc: 'Sözleşme, dilekçe veya herhangi bir hukuki doküman yükleyin (PDF/DOCX/UDF); risk seviyesi, açıklama, öneri ve önerilen yeniden yazım ile Risk Haritası tablosu alın. Word veya PDF olarak dışa aktarın.',
    diffCardTitle: 'Doküman Karşılaştırma',
    diffCardDesc: 'İki veya daha fazla dokümanı (sözleşme, dilekçe, taslak sürümleri) karşılaştırın. Madde bazlı farklar, eklenen/çıkarılan hükümler ve anlam değişiklikleri gerekçesiyle listelenir.',
    caseLawCardTitle: 'İçtihat / Emsal',
    caseLawCardDesc: 'UYAP emsal indeksinde mahkeme kararlarında arama. Daire, esas no, karar no ve tarih aralığına göre filtreleyin.',
    generatorCardTitle: 'Doküman Üretici',
    generatorCardDesc: 'AI ile sözleşme, dilekçe, politika, rehber, bilgi notu üretin veya hazır hukuki belge şablonlarından sözleşme, dilekçe, protokol, ihtar ve daha fazlasını oluşturun. DOCX + PDF olarak indirin.',
    recentActivity: 'Son Aktiviteler',
    noRecentActivity: 'Henüz aktivite yok.',
    taskTypes: {
      contract_analysis: 'Doküman Analizi',
      legislation_diff: 'Mevzuat Karşılaştırma',
      custom_document_diff: 'Özel Doküman Karşılaştırma',
      document_generation: 'Doküman Üretimi',
      upload: 'Dosya Yükleme',
      export: 'Dışa Aktarma',
      format_convert: 'Biçim Dönüştürme',
    },
  },
  contract: {
    title: 'Doküman Analizi',
    desc: 'Risk Haritası ve isteğe bağlı önerilen metin için bir doküman (sözleşme, dilekçe vb. — PDF, DOCX veya UDF) yükleyin.',
    selectFile: 'Dosya (PDF/DOCX)',
    docNameOptional: 'Belge adı (isteğe bağlı)',
    upload: 'Yükle',
    uploading: 'Yükleniyor…',
    runAnalysis: 'Analizi çalıştır',
    analyzing: 'Analiz ediliyor…',
    uploaded: 'Yüklendi',
    exportWord: 'Word\'e aktar',
    assistantTitle: 'Analiz hakkında sor',
    assistantHint: 'Ekrandaki doküman analizi hakkında soru sorabilirsiniz.',
    exportPdf: 'PDF\'e aktar',
    exporting: 'Aktarılıyor…',
    showSuggestedWording: 'Önerilen metni göster',
    suggestedWordingFull: 'Önerilen metin (tam)',
    sectionClause: 'Madde / Fıkra',
    riskLevel: 'Risk Seviyesi',
    riskExplanation: 'Risk Açıklaması',
    recommendation: 'Öneri',
    suggestedRewrite: 'Önerilen Yeniden Yazım',
    contractType: 'Sözleşme Türü',
    overallRisk: 'Genel Risk Skoru',
    riskSummary: 'Genel Değerlendirme',
    clauseType: 'Madde Türü',
    keyTerms: 'Önemli Unsurlar',
    findings: 'Bulgular',
    issue: 'Risk',
    legalBasis: 'Yasal Dayanak',
    missingClauses: 'Eksik / Önerilen Maddeler',
    missingClausesDesc: 'Bu sözleşme türü için beklenen ancak metinde tespit edilemeyen standart korumalar:',
    noMissingClauses: 'Beklenen standart maddelerin tümü mevcut görünüyor.',
    filterSeverity: 'Risk seviyesine göre filtrele',
    all: 'Tümü',
    showRewrite: 'Önerilen metni göster',
    detectedType: 'Tespit edilen tür',
    findingsCount: 'bulgu',
    viewSource: 'Kaynağı gör',
    execSummary: 'Yönetici Değerlendirmesi',
    favours: 'Sözleşmenin dengesi',
    topRisks: 'Öne Çıkan Riskler',
    dealBreakers: 'İmzadan Önce Mutlaka Değişmeli',
    compliance: 'Uyum Uyarıları',
    negotiationPlan: 'Pazarlık Planı',
    keyTermsDoc: 'Sözleşmenin Temel Şartları',
    marketStandard: 'Piyasa standardı',
    negotiationPosition: 'Pazarlık pozisyonu',
    exposure: 'Maruz kalınan risk',
    invalidityRisk: 'Geçersizlik riski',
    analyzingDeep: 'Derin analiz yapılıyor',
  },
  caselaw: {
    title: 'İçtihat / Emsal',
    desc: 'UYAP emsal indeksindeki mahkeme kararlarında arama. Anahtar kelime girin veya boş bırakarak son kararları listeleyin; isteğe bağlı karar tarihi filtresi.',
    query: 'Arama',
    queryPlaceholder: 'Anahtar kelimeler (veya boş bırakın)',
    fromDate: 'Başlangıç tarihi',
    toDate: 'Bitiş tarihi',
    sortOrder: 'Sıralama',
    sortNewest: 'Önce en yeni (karar tarihi)',
    sortOldest: 'Önce en eski (karar tarihi)',
    chamber: 'Daire',
    chamberPlaceholder: 'Örn. 11. HD',
    esasNo: 'Esas No',
    kararNo: 'Karar No',
    sourceType: 'Kaynak Türü',
    courtType: 'Mahkeme Türü',
    courtTypeAll: 'Tüm mahkemeler',
    chamberAll: 'Tüm daireler',
    sourceAll: 'Tümü',
    sourceYargitay: 'Yargıtay',
    sourceDanistay: 'Danıştay',
    sourceBolgeAdliye: 'Bölge Adliye',
    tabDecisions: 'Yargı Kararları',
    tabMinistry: 'Bakanlık Kararları',
    relatedDocs: 'İlgili Mevzuat ve Bakanlık Belgeleri',
    docsLegislation: 'Mevzuat',
    docsMinistry: 'Bakanlık Kararları',
    showMore: 'Daha fazla göster',
    showLess: 'Daha az göster',
    sourceMevzuat: 'Mevzuat',
    sourceBakanlik: 'Bakanlık',
    filters: 'Filtreler',
    advancedFilters: 'Gelişmiş Filtreler',
    clearFilters: 'Tümünü temizle',
    search: 'Ara',
    searching: 'Aranıyor…',
    searchFailed: 'Arama başarısız',
    apiUnreachable: 'API\'ye ulaşılamıyor. Lütfen daha sonra tekrar deneyin veya yöneticinize başvurun.',
    notConfigured: 'İçtihat arama şu anda kullanılamamaktadır. Lütfen daha sonra tekrar deneyin.',
    resultsCount: '{total} sonuçtan {count} tanesi gösteriliyor',
    resultsRange: '{from}–{to} arası gösteriliyor, toplam {total} sonuç (sayfa {page}/{totalPages})',
    pageOf: 'Sayfa {page} / {totalPages}',
    prevPage: 'Önceki',
    nextPage: 'Sonraki',
    noBodyText: 'Karar metni bu kayıtta indekslenmemiş veya farklı bir alan adıyla geliyor. UYAP bağlantısından tam metni açmayı deneyin.',
    compareFailed: 'Karşılaştırma başarısız oldu.',
    noTextForCompare: 'Seçilen kararlardan birinde veya ikisinde tam metin yok; karşılaştırma için indekslenmiş metin gerekir.',
    noResults: 'Karar bulunamadı.',
    viewOnUyap: 'UYAP\'ta görüntüle',
    showFull: 'Kararın tamamını göster',
    downloadPdf: 'PDF İndir',
    downloadText: 'Metin İndir',
    summarize: 'Özetle',
    summarizing: 'Özetleniyor…',
    summaryTitle: 'AI Özet',
    keyPrinciples: 'Temel İlkeler',
    relevance: 'İlgililik',
    compare: 'Karşılaştır',
    comparing: 'Karşılaştırılıyor…',
    selectToCompare: 'Karşılaştırmak için 2 karar seçin',
    compareSelected: 'Seçilenleri Karşılaştır',
    commonPrinciples: 'Ortak İlkeler',
    differences: 'Farklılıklar',
    analysis: 'Analiz',
    relatedLegislation: 'İlgili Mevzuat',
    loadingRefs: 'Mevzuat referansları yükleniyor…',
    noRefsFound: 'Mevzuat referansı bulunamadı.',
    semanticSearch: 'Anlamsal sıralama (kavramsal arama)',
    semanticSearchHint:
      'Tam cümle veya kavramsal sorgularda (ör. iş kazası sonrası tazminat) daha iyi sonuç verir. Azure’da anlamsal yapılandırma gerekir; en fazla 50 sonuç döner.',
    semanticActive: 'Anlamsal sıralama kullanıldı',
    semanticFallback: 'Anlamsal sıralama kullanılamadı; anahtar kelime aramasına dönüldü.',
  },
  ministry: {
    title: 'Bakanlık Kararları',
    desc: 'Tüm bakanlıkların yönetmelik, tebliğ, genelge ve kararlarında arama yapın.',
    query: 'Arama',
    queryPlaceholder: 'Anahtar kelimeler (veya boş bırakın)',
    bakanlik: 'Bakanlık',
    allMinistries: 'Tüm Bakanlıklar',
    type: 'Tür',
    allTypes: 'Tüm Türler',
    kararNo: 'Karar No',
    kararNoPlaceholder: 'Örn. 2024/15',
    fromDate: 'Başlangıç tarihi',
    toDate: 'Bitiş tarihi',
    clearFilters: 'Filtreleri temizle',
    search: 'Ara',
    searching: 'Aranıyor…',
    resultCount: '{n} sonuç',
    noResults: 'Sonuç bulunamadı.',
    viewSource: 'Kaynağı gör',
    notConfigured: 'Bakanlık kararları indeksi henüz yapılandırılmadı. Verileri yüklemek için scripts/sync_bakanlik_decisions.py çalıştırın ve SEARCH_BAKANLIK_INDEX ayarlayın.',
  },
  chat: {
    placeholder: 'Bir soru sorun…',
    // The cards show a short label and a one-line hint; clicking inserts the full question
    // below into the composer. No heading above them - four cards on an empty screen are
    // self-evidently suggestions, and "Örnek sorular" only took up a line saying so.
    example1Label: 'Giydirilmiş ücret',
    example1Hint: 'Kıdem ve ihbarda hesap esası, Yargıtay kararlarıyla',
    example1: 'Kıdem ve ihbar tazminatı hesabında esas alınan giydirilmiş ücret nedir? Yargıtay kararlarıyla açıkla.',
    example2Label: 'Rekabet yasağı',
    example2Hint: 'Sözleşmede geçerli süre ve yer sınırları',
    example2: 'İş sözleşmesindeki rekabet yasağı maddesi hangi süre ve yer sınırlarına tabidir?',
    example3Label: 'Özlük dosyası',
    example3Hint: 'KVKK kapsamında saklama süresi ve imha',
    example3: 'KVKK kapsamında çalışan özlük dosyalarının saklanma süresi ne olmalı?',
    example4Label: 'İhtarname taslağı',
    example4Hint: 'Haklı nedenle fesih için örnek metin',
    example4: 'Haklı nedenle fesih için örnek bir ihtarname taslağı hazırla.',
    inputPlaceholder: 'Sorunuzu yazın…',
    send: 'Gönder',
    sending: 'Gönderiliyor…',
    you: 'Siz',
    assistantName: 'B-Agent Law Assistant',
    statusThinking: 'Düşünüyor…',
    statusTool: 'Kaynaklar inceleniyor…',
    statusTool_search_mevzuat: 'Mevzuat aranıyor…',
    statusTool_search_caselaw: 'İçtihat aranıyor…',
    statusTool_search_case_docs: 'Dosya belgeleri aranıyor…',
    statusTool_analyze_contract: 'Belge analiz ediliyor…',
    statusTool_compare_documents: 'Belgeler karşılaştırılıyor…',
    statusTool_compare_articles: 'Maddeler karşılaştırılıyor…',
    statusTool_draft_document: 'Taslak hazırlanıyor…',
    statusTool_calculate: 'Hesaplanıyor…',
    statusTool_search_web: 'Web’de aranıyor…',
    error: 'Yanıt alınamadı.',
    expand: 'Tam ekranda aç',
    newChat: 'Yeni sohbet',
    edit: 'Düzenle',
    previousVersions: 'Önceki {n} yanıt',
    previousNoReply: '(yanıt alınamamıştı)',
    resend: 'Yeniden gönder',
    history: 'Sohbet geçmişi',
    noHistory: 'Henüz sohbet yok.',
    messagesCount: 'mesaj',
    deleteConvo: 'Sohbeti sil',
    hideSidebar: 'Geçmişi gizle',
    showSidebar: 'Geçmişi göster',
    attachFile: 'Dosya ekle (PDF/DOCX/TXT)',
    removeFile: 'Eki kaldır',
    fileAttached: 'Eklendi',
    speakMessage: 'Sesli oku',
    stopSpeaking: 'Okumayı durdur',
    startListening: 'Konuş (sesli giriş)',
    stopListening: 'Dinlemeyi durdur',
    sttNotSupported: 'Bu tarayıcıda sesli giriş desteklenmiyor',
    exportWord: 'Word İndir',
    exportPdf: 'PDF İndir',
    exporting: 'İndiriliyor…',
  },
  chatCard: {
    articleCompare: 'Madde karşılaştırma',
    openFullAnalysis: 'Tam analizi aç',
    openFullComparison: 'Tam karşılaştırmayı aç',
    moreFindings: '+{n} bulgu daha',
    caseDocs: 'Dosya belgelerinizden',
    fromCases: '{n} dosya tarandı',
    readSource: 'Kararın tam metnini burada oku',
    loadingSource: 'Karar metni getiriliyor…',
    openSource: 'Kaynağı yeni sekmede aç',
    sources: 'Kaynaklar',
    myDocuments: 'Belgeleriniz',
    analyzing: 'Sözleşme analiz ediliyor…',
    riskMap: 'Risk Haritası',
    riskScore: 'Risk skoru: {n}',
    comparing: 'Belgeler karşılaştırılıyor…',
    comparison: 'Karşılaştırma',
    drafting: 'Belge hazırlanıyor…',
    document: 'Belge taslağı',
    blockCount: '{n} bölüm',
    showFull: 'Tamamını göster',
    showLess: 'Daha az göster',
    openInStudio: 'Doküman Üretici’de aç',
    caselaw: 'Bulunan kararlar',
    web: 'Web sonuçları',
    webNote: 'Resmî kaynak değildir; kullanmadan önce kaynağında doğrulayın.',
    mevzuat: 'İlgili mevzuat',
    calculation: 'Hesaplama',
    showingOf: '{total} sonuçtan {count} tanesi',
  },
  sidebar: {
    talents: 'Yetenekler',
    chats: 'Sohbetler',
    showSection: 'Bölümü aç',
    hideSection: 'Bölümü gizle',
    searchChats: 'Sohbetlerde ara…',
    noChatMatch: 'Eşleşen sohbet yok.',
  },
  copilot: {
    title: 'B-Agent Asistan',
    collapsePanel: 'Paneli daralt',
    expandPanel: 'Asistanı aç',
    contextChipTitle: 'Asistan şu anda açık olan sayfayı biliyor.',
    contextHint: 'Kullanıcı şu anda "{page}" sayfasında. Soruyu bu sayfa bağlamında yanıtla.',
    emptyTitle: 'Ne yapmak istiyorsunuz?',
    emptyDesc: 'Sorunuzu yazın ya da aşağıdaki önerilerden birini seçin.',
    prompts: {
      whatCanIDo: 'Bu sayfada neler yapabilirim?',
      summarizeDay: 'Bekleyen işlerimi özetle',
      riskyClauses: 'Sözleşmedeki riskli maddeler neler?',
      explainAnalysis: 'Analiz sonucunu sade dille açıkla',
      findPrecedent: 'Konuyla ilgili emsal karar bul',
      summarizeDecision: 'Bu kararı özetle',
      recentDecisions: 'Son bakanlık kararlarını göster',
      whichCalculation: 'Hangi hesaplamayı kullanmalıyım?',
      caseStatus: 'Dosyalarımın durumu ne?',
      whichFormat: 'Hangi biçime dönüştürmeliyim?',
    },
  },
  hesaplama: {
    selectCalculator: 'Hesaplama türü',
    title: 'Hesaplamalar',
    desc: 'Hukuki hesaplama araçları – sonuçlar mevzuata dayalı, deterministik formüllerle üretilir.',
    soon: 'Yakında',
    hesapla: 'Hesapla',
    faiz: 'Faiz Hesaplama',
    anapara: 'Anapara',
    faizOrani: 'Faiz Oranı',
    baslangic: 'Başlangıç Tarihi',
    bitis: 'Bitiş Tarihi',
    yontem: 'Yöntem',
    basit: 'Basit Faiz',
    bilesik: 'Bileşik Faiz',
    gun: 'Gün',
    faizTutari: 'Faiz Tutarı',
    toplam: 'Toplam (Anapara + Faiz)',
    vekalet: 'Vekâlet Ücreti (AAÜT)',
    harc: 'Yargı Harcı',
    infaz: 'İnfaz Süresi',
    davaDegeri: 'Dava Değeri',
    vekaletUcreti: 'Vekâlet Ücreti',
    tarife: 'Tarife',
    nispiHarc: 'Nispi Karar ve İlam Harcı',
    pesinHarc: 'Peşin Harç (1/4)',
    cezaYil: 'Ceza (Yıl)',
    cezaAy: 'Ceza (Ay)',
    cezaGun: 'Ceza (Gün)',
    mahsup: 'Mahsup (Tutukluluk) Gün',
    sucTipi: 'Suç Tipi',
    infazSuresi: 'İnfaz Süresi (kurumda)',
    ksKalan: 'Koşullu Salıvermeye Kalan',
    denetimli: 'Denetimli Serbestlik',
    fiilenKurum: 'Fiilen Kurumda Kalınacak',
    // Kıdem / İhbar / İzin
    tazminat: 'Kıdem / İhbar / İzin',
    iseBaslama: 'İşe Başlama Tarihi',
    isAyrilma: 'İşten Ayrılma Tarihi',
    brutUcret: 'Aylık Brüt Ücret (giydirilmiş)',
    kidemTavani: 'Kıdem Tavanı (boş = güncel)',
    kullanilmayanIzin: 'Kullanılmayan İzin (gün)',
    hizmetSuresiLbl: 'Hizmet Süresi',
    kidemTazminati: 'Kıdem Tazminatı (net)',
    ihbarTazminati: 'İhbar Tazminatı (net)',
    izinUcreti: 'Yıllık İzin Ücreti (brüt)',
    brutLbl: 'Brüt',
    netLbl: 'Net',
    // Damga
    damga: 'Damga Vergisi',
    tutar: 'Tutar',
    damgaTuru: 'Belge Türü',
    damgaSozlesme: 'Sözleşme (binde 9,48)',
    damgaUcret: 'Ücret / Tazminat (binde 7,59)',
    damgaKira: 'Kira (binde 1,89)',
    oranBinde: 'Oran (binde)',
    damgaVergisi: 'Damga Vergisi',
    // KDV
    kdv: 'KDV',
    kdvOran: 'KDV Oranı (%)',
    kdvMod: 'Hesaplama',
    kdvHaric: 'KDV Hariç (üzerine ekle)',
    kdvDahil: 'KDV Dahil (içinden ayır)',
    matrah: 'Matrah',
    kdvTutari: 'KDV Tutarı',
    // Kira
    kira: 'Kira Artışı',
    mevcutKira: 'Mevcut Kira (TL)',
    tufeOrani: 'TÜFE Oranı (%)',
    kiraTuru: 'Kira Türü',
    kiraKonut: 'Konut (%25 tavan)',
    kiraIsyeri: 'İşyeri (tavansız)',
    uygulananOran: 'Uygulanan Oran',
    artisTutari: 'Artış Tutarı',
    yeniKira: 'Yeni Kira',
    // Nafaka
    nafaka: 'Nafaka Artışı',
    mevcutNafaka: 'Mevcut Nafaka (TL)',
    artisOrani: 'Artış Oranı (%)',
    yeniNafaka: 'Yeni Nafaka',
    // Gecikme zammı
    gecikme: 'Gecikme Zammı',
    borc: 'Borç (TL)',
    vade: 'Vade Tarihi',
    odeme: 'Ödeme Tarihi',
    aylikOran: 'Aylık Oran (%)',
    gecikmeZammi: 'Gecikme Zammı',
  },
  uyap: {
    title: 'Dosyalarım (UYAP)',
    desc: 'UYAP avukat ve kurumsal belgelerinizi dava bazında klasörlerde saklayın, gelişmelerden haberdar olun ve belgeleriniz hakkında doğrudan AI’ya sorun.',
    // e-imza gate
    eimzaTitle: 'E-imza / Mobil imza doğrulaması',
    eimzaDesc: 'Bu bölüm UYAP belgelerinizi içerir. Erişmek için e-imza veya mobil imza ile kimliğinizi doğrulayın.',
    eImzaCard: 'E-imza (kart)',
    eImzaCardVerify: 'Kartımla doğrula',
    eImzaCardHint: 'Kartınız takılı olsun. Doğrula\'ya bastığınızda tarayıcı sertifika seçmenizi ister, ardından kart yazılımı PIN sorar. İmza kartın içinde üretilir; PIN veya özel anahtar hiçbir zaman sunucuya gitmez.',
    eimzaNoCert: 'Tarayıcı kart sertifikası göndermedi. Sertifika seçme penceresi açılmadıysa sunucu tarafında istemci sertifikası ayarı açık değil demektir.',
    eimzaTicketStale: 'Doğrulama isteği zaman aşımına uğradı. Tekrar deneyin.',
    eimzaCardRefused: 'Kart sertifikası kabul edilmedi ({reason}).',
    eimzaNoProvider: 'E-imza doğrulaması bu kurulumda yapılamıyor. Kartınız bilgisayarınızda olsa bile imza tarayıcıda oluşturulur ve sunucunun bunu doğrulaması için lisanslı bir doğrulama sağlayıcısı (Kamu SM veya mobil imza için GSM operatörü) gerekir. Böyle bir sağlayıcı tanımlı olmadığı ve katı mod açık olduğu için doğrulama denemesi her durumda başarısız olur. Bu bir yapılandırma/sözleşme adımıdır; uygulama tarafında yapılacak bir şey yok.',
    eimzaDemoNote: 'Gerçek imza sağlayıcısı yapılandırılmadı; bu ortamda doğrulama akışı demo amaçlıdır. Üretimde Kamu SM / GSM mobil imza sağlayıcısı bağlanmalıdır.',
    mobilImza: 'Mobil İmza',
    eImza: 'E-imza (akıllı kart)',
    tckn: 'T.C. Kimlik No',
    phone: 'Cep Telefonu',
    eImzaHint: 'Akıllı kartınızı takın ve ara yazılımın çalıştığından emin olun, ardından doğrulayın.',
    verify: 'Doğrula',
    verifying: 'Doğrulanıyor…',
    eimzaFailed: 'İmza doğrulanamadı.',
    // cases
    casesTitle: 'Dosyalar',
    newCase: 'Yeni Dosya',
    caseNo: 'Dosya No (ör. 2024/123 E.)',
    caseTitle: 'Dosya Başlığı',
    court: 'Mahkeme / Birim',
    client: 'Müvekkil',
    create: 'Oluştur',
    noCases: 'Henüz dosya yok. Yeni bir dosya oluşturun.',
    selectCase: 'Detayları görmek için bir dosya seçin.',
    notFound: 'Dosya bulunamadı.',
    docs: 'belge',
    // detail
    documents: 'Belgeler',
    uploadDoc: 'Belge Yükle',
    uploading: 'Yükleniyor…',
    noDocs: 'Bu dosyada belge yok.',
    uploaded: 'Yüklendi',
    sync: 'UYAP’tan Senkronize Et',
    progress: 'Dava Gelişmeleri',
    progressTitle: 'Gelişme başlığı (ör. Duruşma ertelendi)',
    progressDetail: 'Açıklama (opsiyonel)',
    notifyEmail: 'Bildirim e-postası (opsiyonel)',
    notifyEmailDisabled: 'E-posta bildirimi yapılandırılmadı',
    addProgress: 'Gelişme Ekle',
    noProgress: 'Henüz gelişme kaydı yok.',
    // ask AI
    askTitle: 'AI Asistan – bu dosya hakkında',
    askPlaceholder: 'Bu dosyadaki belgeler hakkında soru sorun; yanıtlar belgelerinize ve mevzuata dayanır.',
    askInput: 'Bu dosya hakkında sorun…',
    askFailed: 'Soru yanıtlanamadı.',
    // notifications
    notifications: 'Bildirimler',
    markAllRead: 'Tümünü okundu işaretle',
    noNotifications: 'Bildirim yok.',
    // Müvekkil TCKN + Vatandaş portalı
    clientTckn: 'Müvekkil T.C. Kimlik No (opsiyonel)',
    clientTcknHint: 'TCKN girilirse, müvekkil Vatandaş portalından bu dosyayı görebilir.',
    portalLawyer: 'Avukat',
    portalCitizen: 'Vatandaş',
    portalKurum: 'Kurum',
    myCasesTitle: 'Dosyalarım',
    citizenNoCases: 'Adınıza kayıtlı dosya bulunamadı. Avukatınız dosyayı T.C. Kimlik No’nuzla eşleştirdiğinde burada görünür.',
    // UYAP portal bağlantısı
    connectTitle: 'UYAP Bağlantısı',
    connectDesc: 'UYAP Avukat, Kurum veya Vatandaş portalına bağlanın; dosyalarınız otomatik olarak klasör klasör içeri aktarılır.',
    connect: 'UYAP’a Bağlan',
    connecting: 'Bağlanılıyor…',
    connectFailed: 'UYAP bağlantısı kurulamadı.',
    connected: 'Bağlı',
    connectedAs: 'Bağlı: {portal}',
    disconnect: 'Bağlantıyı Kes',
    portalAvukat: 'Avukat Portalı',
    portalKurumFull: 'Kurum Portalı',
    portalVatandasFull: 'Vatandaş Portalı',
    certPassword: 'E-imza PIN / sertifika şifresi',
    certHint: 'E-imza sertifikanız akıllı kart/ara yazılım veya lisanslı geçit üzerinden doğrulanır.',
    tcknFromEimza: 'Boş bırakılırsa e-imza kimliğinizden alınır',
    lastSync: 'Son senkronizasyon',
    casesWord: 'dosya',
    syncedSummary: '{cases} dosya bulundu, {docs} yeni belge içeri aktarıldı.',
    mode_external: 'Canlı UYAP geçidi',
    mode_puppeteer: 'Portal otomasyonu',
    mode_demo: 'Demo bağlayıcı',
    mode_none: 'Yapılandırılmadı',
    notConfiguredTitle: 'Canlı UYAP erişimi henüz tanımlı değil',
    notConfiguredDesc: 'İki yoldan biriyle etkinleşir. 1) Büronun lisanslı UYAP geçidi (Adalet Bakanlığı anlaşması). 2) Avukatın kendi e-imzası: e-imza kartı avukatın bilgisayarına takılı olduğu için sunucu avukat adına giriş yapamaz; bu nedenle avukatın kendi makinesinde çalışan bir köprü uygulaması gerekir. Her iki durumda da bu bölüm tek bir ayar (UYAP_SYNC_URL) ile etkinleşir.',
    notConfiguredLawyerNote: 'e-imza yerine mobil imza kullanılıyorsa imzalama telefonda gerçekleştiği için köprü uygulamasına gerek kalmayabilir; bu yol UYAP kullanım koşulları açısından ayrıca değerlendirilmelidir.',
    demoWarning: 'Demo bağlayıcı etkin: gösterilen dosyalar örnektir, gerçek UYAP verisi değildir.',
    // Belge AI özeti
    aiSummary: 'AI Özeti',
    aiSummaryLoading: 'Özet hazırlanıyor…',
    aiSummaryNone: 'Bu belge için henüz özet yok.',
    aiSummaryFailed: 'Özet üretilemedi.',
    showSummary: 'AI Özetini Göster',
    hideSummary: 'Özeti Gizle',
    useInDraft: 'Taslakta Kullan',
    useInDraftHint: 'Bu belgeyi Doküman Üretici’de kaynak olarak kullan',
    // Duruşma takvimi
    hearings: 'Duruşmalar',
    noHearings: 'Planlanmış duruşma yok.',
    nextHearing: 'Sonraki duruşma',
    syncNow: 'Şimdi Senkronize Et',
    syncing: 'Senkronize ediliyor…',
    needsConnection: 'Senkronizasyon için önce UYAP’a bağlanın.',
  },
  convert: {
    title: 'Biçim Dönüştürücü',
    desc: 'Word, PDF, UYAP (.udf) ve metin dosyalarını birbirine dönüştürün. Dosyalar yalnızca dönüştürme sırasında bellekte tutulur, sunucuya kaydedilmez.',
    dropTitle: 'Dosyayı buraya sürükleyin veya seçmek için tıklayın',
    dropHint: 'Word (.docx, .doc), PDF, UYAP (.udf) veya metin (.txt) — en fazla 15 MB',
    badType: 'Desteklenmeyen dosya türü. Word, PDF, UDF veya TXT yükleyin.',
    targetLabel: 'Hedef biçim',
    convert: 'Dönüştür',
    converting: 'Dönüştürülüyor…',
    reset: 'Temizle',
    done: 'Dönüştürme tamamlandı',
    download: 'İndir',
    diMissing: 'Azure Document Intelligence yapılandırılmamış: DOCX, PDF, UDF ve TXT dönüşümleri çalışır, ancak eski .doc dosyaları ve taranmış (görüntü) PDF sayfaları okunamaz.',
    sourceUnavailable: 'Eski .doc biçimini okumak için Azure Document Intelligence gerekiyor ve şu anda yapılandırılmamış. Dosyayı Word’de .docx olarak kaydedip yeniden deneyin.',
  },
  docActions: {
    print: 'Yazdır',
    fillStyle: 'Doldurma alanları',
    fillMarker: 'İşaretli göster (⟪…⟫)',
    fillDots: 'Boş satır (…………)',
    fillUnderscore: 'Boş satır (_____)',
    fillPlain: 'Yalnızca etiket',
    fillCount: '{count} doldurulacak alan',
    fillHint: 'Belgede elle doldurulacak alanlar var. Çıktı ve baskıda bunları boş satıra çevirmek için bir biçim seçin.',
  },
  drafting: {
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    saved: 'Kaydedildi',
    unsavedWarning: 'Bu belge henüz kaydedilmedi. Sayfayı yenilerseniz veya başka bir cihaza geçerseniz kaybolur — saklamak için Kaydet’e basın.',
    savedDocs: 'Kayıtlı belgelerim',
    uploadSources: 'Dosya yükle (kaynak olarak kullan)',
    uploadSourcesHint: 'AI üretirken bu dosyaların ifadelerini, taraf adlarını ve tanımlı terimlerini esas alır. En fazla 5 dosya.',
    uploadingSources: 'Kaynak dosyalar yükleniyor…',
    effort: 'Çaba',
    effortLow: 'Düşük',
    effortMedium: 'Orta',
    effortHigh: 'Yüksek',
    composerGreeting: 'Ne hazırlamamı istersiniz?',
    dictate: 'Sesle yaz',
    dictateStop: 'Durdur',
    dictateUnsupported: 'Sesle yazma bu tarayıcıda desteklenmiyor (Chrome veya Edge kullanın).',
    title: 'Doküman Üretici',
    desc: 'Yapay zekâ ile kaynaklara dayalı sözleşme ve dilekçe oluşturun; her cümlenin dayandığı mevzuat ve içtihatı görün, düzenleyin ve dışa aktarın.',
    tabAi: 'AI ile Oluştur',
    tabTemplates: 'Şablonlar',
    belgeTuru: 'Belge Türü',
    belgeTuruPlaceholder: 'Belge türü seçin (opsiyonel)',
    docTitle: 'Başlık',
    docTitlePlaceholder: 'ör. Gizlilik Sözleşmesi',
    parties: 'Taraflar',
    partiesPlaceholder: 'ör. ABC A.Ş. – XYZ Ltd. Şti.',
    matter: 'Konu / Olay',
    matterPlaceholder: 'Belgenin konusunu ve önemli olguları yazın…',
    instructions: 'Talimatlar',
    instructionsPlaceholder: 'Özel istekler (ör. cezai şart ekle, yetkili mahkeme İstanbul)…',
    talimatlarPlaceholder: 'Ne hazırlamamı istediğinizi anlatın. Örn: "X A.Ş. ile Y Ltd. arasında, yazılım geliştirme hizmeti için bir hizmet sözleşmesi hazırla; bedel aylık 150.000 TL, gizlilik ve cezai şart maddeleri olsun, yetkili mahkeme İstanbul."',
    talimatlarHint: 'Belge türünü, tarafları ve konuyu otomatik anlar; ilgili mevzuat ve içtihatla destekler.',
    advanced: 'Gelişmiş (kaynaklar)',
    sourcesLabel: 'Araştırma Kaynakları',
    addSource: 'Kaynak Ekle (UYAP evrakı / not)',
    addSourcePlaceholder: 'Kaynak başlığı veya dava evrakı adı…',
    add: 'Ekle',
    ownDocs: 'Kendi belgelerim (UYAP / kurumsal)',
    ownDocsHint: 'Dosyalarınızdan belge seçin; AI üretirken bunların ifadelerini, taraf adlarını ve tanımlı terimlerini esas alır.',
    ownDocsNone: 'Henüz dosya yok. "Dosyalarım (UYAP)" bölümünden belge ekleyin.',
    generate: 'Belgeyi Oluştur',
    generating: 'Oluşturuluyor…',
    newDoc: 'Yeni Belge',
    stubWarning: 'AI yapılandırılmadığı için yapısal taslak üretildi (atıf yok).',
    panelChat: 'AI Asistan',
    panelSources: 'Kaynaklar',
    panelAssistant: 'AI Asistan',
    modeAsk: 'Belge hakkında sor',
    modeEdit: 'Belgeyi düzenle',
    askHint: 'Bu belge hakkında soru sorun; yanıtlar belge metnine ve kaynaklara dayanır.',
    editHint: 'Belgenin tamamında istediğiniz değişikliği yazın; AI belgeyi yeniden yazar ve yeni bir sürüm oluşturur.',
    askInput: 'Belge hakkında sorun…',
    editInput: 'Ne değişsin? (ör. cezai şart ekle, tarafları güncelle)…',
    apply: 'Uygula',
    docRevised: 'Belge güncellendi ve yeni sürüm olarak kaydedildi.',
    version: 'Sürüm',
    versions: 'Sürümler',
    noSources: 'Bu belgede atıf yapılan kaynak yok.',
    selectBlock: 'Düzenlemek için belgeden bir bölüm seçin.',
    sectionEdit: 'Seçili bölüm',
    clearSection: 'Seçimi kaldır',
    clickToEdit: 'Düzenlemek için tıklayın',
    editPlaceholder: 'Bu bölümü nasıl değiştireyim? (ör. daha sıkı yaz, madde ekle)',
    applyEdit: 'Uygula',
    editing: 'Düzenleniyor…',
    emailSubject: 'Konu',
    model: 'AI Seçimi (Model)',
    modelUnavailable: 'sunucuda yapılandırılmadı',
    modelUnavailableHint: 'Derin model sunucuda tanımlı değil. Yönetici AZURE_AI_SMART_DEPLOYMENT ayarını eklediğinde bu seçenek etkinleşir.',
    modelSmart: 'Derin model',
    modelSmartHint: 'Muhakeme modeli: planlama, madde madde yazım, kıdemli ortak denetimi. Daha yavaş, çok daha derin.',
    modelFast: 'Hızlı model',
    modelFastHint: 'Aynı hattı daha hızlı çalıştırır; derinlik bir tık düşer.',
    depth: 'Derinlik',
    depthFull: 'Tam (denetim + avukat notu)',
    depthQuick: 'Hızlı (yalnızca taslak)',
    pipelinePlan: 'Talimat hukuken analiz ediliyor',
    pipelineRunning: 'Belge hazırlanıyor',
    panelNotes: 'Avukat Notu',
    notesSummary: 'Özet',
    notesOpenPoints: 'Teyit edilmesi gerekenler',
    notesRisks: 'Kalan riskler',
    notesNegotiation: 'Pazarlık notları',
    notesChecklist: 'İmza öncesi kontrol listesi',
    notesNextSteps: 'Sonraki adımlar',
    notesNone: 'Bu belge için avukat notu üretilmedi.',
    reviewVerdict: 'Denetim sonucu',
    reviewIssues: 'Denetimde düzeltilen noktalar',
    assumption: 'Kullanılan varsayım',
    editNote: 'Değişiklik gerekçesi',
    modelBadge: 'Model',
  },
  generator: {
    title: 'Doküman Üretici',
    assistantTitle: 'AI Asistan',
    assistantHint: 'Doküman üretiminde yardımcı ol: taslak metin, madde önerisi ve düzeltme. Yalnızca gerçek Türk mevzuatı ve içtihadına dayan; emin olmadığın madde/karar numarası uydurma.',
    history: 'Geçmiş',
    historyTitle: 'Önceki Belgeler',
    historyClear: 'Geçmişi Temizle',
    desc: 'AI şablonlarıyla politika ve rehber üretin veya hazır hukuki belge formlarından sözleşme, protokol, ihtar oluşturun.',
    searchPlaceholder: 'Şablon veya belge adı arayın…',
    noTemplates: 'Eşleşen şablon bulunamadı.',
    loadError: 'Şablonlar yüklenemedi. Lütfen sayfayı yenileyin.',
    aiTemplates: 'AI Şablonları',
    legalTemplates: 'Hukuki Belge Şablonları',
    aiPowered: 'AI',
    questions: 'soru',
    backToTemplates: 'Şablonlara dön',
    backToForm: 'Forma dön',
    topic: 'Konu',
    topicPlaceholder: 'Dokümanın ana konusu',
    scope: 'Kapsam (isteğe bağlı)',
    scopePlaceholder: 'Hangi birim/süreçleri kapsıyor',
    targetAudience: 'Hedef Kitle (isteğe bağlı)',
    targetAudiencePlaceholder: 'Örn: Tüm çalışanlar, Hukuk ekibi',
    keyPoints: 'Temel Noktalar (isteğe bağlı)',
    keyPointsPlaceholder: 'Her satıra bir madde yazın',
    selectOption: '– Seçin –',
    loadingFields: 'Sorular yükleniyor…',
    generate: 'Oluştur',
    generating: 'Oluşturuluyor…',
    result: 'Oluşturulan Doküman',
    disclaimer: '',
    copyToClipboard: 'Kopyala',
    copied: 'Kopyalandı!',
    downloadDocx: 'DOCX İndir',
    downloadPdf: 'PDF İndir',
  },
  diff: {
    title: 'Mevzuat Karşılaştırma',
    assistantTitle: 'AI Asistan',
    assistantHint: 'Mevzuat ve doküman karşılaştırmasında yardımcı ol: maddeleri açıkla, değişikliklerin etkisini yorumla. Yalnızca gerçek Türk mevzuatı ve içtihadına dayan; emin olmadığın madde/karar numarası uydurma.',
    clickRowHint: 'Bir satıra tıklayarak o değişikliği AI asistan ile tartışabilirsiniz.',
    assistantHintCustom: 'Aşağıda yüklenen iki belgenin metni var. Bu belgelere ve gerçek Türk mevzuatı/içtihadına dayanarak farkları açıkla; emin olmadığın madde/karar numarası uydurma.',
    history: 'Geçmiş',
    historyTitle: 'Önceki Karşılaştırmalar',
    historyClear: 'Geçmişi Temizle',
    desc: 'Küratör veri setinden bir kanun ve iki sürüm seçin. Karşılaştırma kaynak önceliklidir; eksik kaynak sonucu reddeder.',
    law: 'Kanun',
    oldVersion: 'Eski sürüm',
    newVersion: 'Yeni sürüm',
    runDiff: 'Karşılaştırmayı çalıştır',
    running: 'Karşılaştırma çalışıyor…',
    select: '– Seçin –',
    refusalTitle: 'Red: kaynak gerekli',
    missingSources: 'Eksik kaynaklar',
    articleClause: 'Madde / Fıkra',
    oldText: 'Eski Metin',
    newText: 'Yeni Metin',
    changeType: 'Değişiklik Türü',
    summaryImpact: 'Özet / Etki Notu',
    sources: 'Kaynaklar',
    export: 'Dışa Aktar',
    exportText: 'Metin Olarak Dışa Aktar',
    liveData: 'Canlı mevzuat verisi',
    lawsIndexed: 'kanun indekslendi',
    lawNoShort: 'No.',
    lawNoPrefix: 'No:',
    articleLabel: 'Madde',
    typeaheadMore: 'daha fazla kanun – aramayı daraltın',
    firstLaw: 'Birinci Kanun',
    secondLaw: 'İkinci Kanun',
    searchLaw: 'Kanun adı veya numarasını yazarak arayın…',
    selectTwoLaws: 'Karşılaştırmak için iki farklı kanun seçin',
    compareLaws: 'Kanun Karşılaştır',
    browseLaw: 'Kanun Görüntüle',
    selectLawToBrowse: 'Maddelerini görmek için bir kanun seçin',
    articles: 'madde',
    filterArticles: 'Madde numarası veya anahtar kelime ile filtreleyin…',
    loadingArticles: 'Maddeler yükleniyor…',
    loadingLaws: 'Kanunlar yükleniyor…',
    noArticles: 'Madde bulunamadı.',
    uploadCompare: 'Doküman Karşılaştır',
    uploadDocs: 'Belge ekle (2–5)',
    uploadDocsHint: 'En fazla {max} belge karşılaştırılabilir. Biri "referans" seçilir, diğerleri ona göre karşılaştırılır.',
    baseline: 'Referans',
    setBaseline: 'Referans yap',
    uploadDocA: 'Doküman A',
    uploadDocB: 'Doküman B',
    uploadAndCompare: 'Yükle ve Karşılaştır',
    uploading: 'Yükleniyor…',
    mixedCompare: 'Karma Karşılaştırma',
    fromIndex: 'Dizinden',
    fromUpload: 'Yükle',
    exportCsv: 'CSV Olarak Dışa Aktar',
  },
  audit: {
    title: 'Aktivite / Denetim',
    desc: 'Yöneticiler tüm kullanıcıların aktivitesini görür. İnceleyiciler yalnızca kendi kayıtlarını görür. Sütunlar: kullanıcı, zaman, görev türü, araçlar, kaynaklar, çıktı sürümü.',
    time: 'Zaman',
    user: 'Kullanıcı',
    taskType: 'Görev türü',
    toolsCalled: 'Kullanılan araçlar',
    sourcesUsed: 'Kullanılan kaynaklar',
    outputVersion: 'Çıktı sürümü',
    noActivity: 'Henüz aktivite yok.',
    descAdmin: 'Tüm kullanıcıların aktivite kayıtları. Kullanıcı, görev türü ve tarih aralığına göre filtreleyin; aynı seçimi CSV/JSON olarak dışa aktarın.',
    filterUser: 'Kullanıcı',
    allUsers: 'Tüm kullanıcılar',
    filterTask: 'Görev türü',
    allTasks: 'Tüm görevler',
    from: 'Başlangıç',
    to: 'Bitiş',
    clearFilters: 'Filtreleri temizle',
    exportCsv: 'CSV indir',
    exportJson: 'JSON indir',
    showing: '{count} kayıt gösteriliyor',
    showingOf: '{total} kaydın en yenisi {count} tanesi gösteriliyor',
    loading: 'Kayıtlar yükleniyor…',
    noMatch: 'Bu filtrelere uyan kayıt bulunamadı.',
  },
  settings: {
    title: 'Ayarlar',
    desc: 'Görünüm ve tercihler.',
    appearance: 'Görünüm',
    theme: 'Tema',
    light: 'Açık',
    dark: 'Koyu',
    about: 'Hakkında',
    aboutText: 'B-Agent Law – Yapay Zeka Destekli Hukuk Asistanı. Sözleşme analizi, mevzuat karşılaştırma, içtihat arama ve doküman üretimi.',
    retentionTitle: 'Veri saklama ve silme (KVKK)',
    retentionNote: 'Belgeler istediğiniz zaman belge listesinden silinebilir. Saklama politikası yapılandırılmışsa, saklama süresini aşan belgeler yönetici tarafından kaldırılabilir. Saklama politikası için yöneticinize veya KVKK sorumlusuna başvurun.',
    retentionDays: 'Saklama politikası: {{days}} günden eski belgeler kaldırılabilir.',
    retentionNotConfigured: 'Saklama politikası: yapılandırılmadı.',
    retentionRun: 'Saklamayı şimdi çalıştır',
    retentionRunSuccess: 'Saklama tamamlandı. {{count}} belge kaldırıldı.',
    statsTitle: 'Kullanım İstatistikleri',
    statsNote: 'Son denetim kayıtlarına dayalı kullanım özeti (yalnızca sizin aktiviteniz).',
    statsNoteAdmin: 'Son denetim kayıtlarına dayalı kurum geneli kullanım özeti (tüm kullanıcılar).',
    documentsAnalyzed: 'Analiz Edilen',
    diffsRun: 'Karşılaştırma',
    searchesRun: 'Arama',
  },
  admin: {
    publish: 'Tüm kullanıcılar için yayınla',
    publishing: 'Yayınlanıyor…',
    published: 'Yayınlandı — tüm kullanıcılar bu görünümü görecek.',
    publishHint: 'Yukarıdaki düzenlemeler yalnızca bu tarayıcıyı etkiler. Yayınlamak, markayı tüm kullanıcılar için kaydeder.',
    title: 'Yönetim Paneli',
    desc: 'Açık ve koyu temalar için marka renklerini, degradeleri ve logoları özelleştirin.',
    branding: 'Marka',
    darkTheme: 'Koyu Tema',
    lightTheme: 'Açık Tema',
    colors: 'Renkler',
    accentColor: 'Vurgu / Ana Renk',
    secondaryBtnColor: 'İkincil Buton Rengi',
    headerBg: 'Başlık Arka Planı',
    backgroundColor: 'Sayfa Arka Planı',
    surfaceColor: 'Kart / Yüzey Rengi',
    titleColor: 'Metin Rengi (Başlıklar)',
    bodyColor: 'Metin Rengi (Gövde)',
    textColor: 'Metin Rengi (Genel)',
    lineColor: 'Çizgi / Kenarlık Rengi',
    highlightColor: 'Vurgulama Rengi',
    navLinkColor: 'Başlık Bağlantı Rengi',
    navLinkActive: 'Başlık Bağlantı Aktif / Hover',
    sidebarAccent: 'Kenar Çubuğu Vurgu Rengi',
    gradients: 'Degradeler',
    headerGradient: 'Başlık Degradesi',
    bgGradient: 'Arka Plan Degradesi',
    logo: 'Şirket Logosu',
    logoForTheme: '{theme} için logo',
    uploadLogo: 'Yükle',
    changeLogo: 'Değiştir',
    resetDefault: 'Varsayılana sıfırla',
    resetAll: 'Tümünü varsayılana sıfırla',
  },
  usage: {
    title: 'Kullanım Raporları',
    from: 'Başlangıç',
    to: 'Bitiş',
    userId: 'Kullanıcı',
    allUsers: 'Tüm kullanıcılar',
    loading: 'Yükleniyor…',
    refresh: 'Yenile',
    totalEvents: 'Toplam İşlem',
    servicesUsed: 'Kullanılan Hizmetler',
    activeUsers: 'Aktif Kullanıcılar',
    serviceUsage: 'Hizmet Kullanımı',
    topKeywords: 'En Çok Aranan Kelimeler',
    perUser: 'Kullanıcı Bazlı Dağılım',
    dailyActivity: 'Günlük Aktivite',
    breakdown: 'Dağılım',
    noData: 'Veri bulunamadı.',
    coverageNote: 'Dağılım, toplam {total} işlemin en son {covered} tanesine dayanmaktadır.',
    svc_chat: 'Sohbet',
    svc_case_law_search: 'İçtihat Arama',
    svc_case_law_summarize: 'İçtihat Özet',
    svc_case_law_compare: 'İçtihat Karşılaştırma',
    svc_stt: 'Konuşmadan Metne',
    svc_tts: 'Metinden Sese',
    svc_chat_export: 'Sohbet Dışa Aktarma',
    svc_contract_analysis: 'Doküman Analizi',
    svc_legislation_diff: 'Mevzuat Karşılaştırma',
    svc_legislation_live_diff: 'Canlı Mevzuat Karşılaştırma',
    svc_legislation_mixed_diff: 'Karma Mevzuat Karşılaştırma',
    svc_custom_document_diff: 'Özel Belge Karşılaştırma',
    svc_document_generation: 'Doküman Üretimi',
    svc_mevzuat_search: 'Mevzuat Arama',
    svc_mevzuat_articles: 'Mevzuat Maddeleri',
    svc_mevzuat_article_search: 'Madde İçi Arama',
    svc_upload: 'Belge Yükleme',
    svc_export: 'Dışa Aktarma',
    svc_unknown: 'Diğer',
  },
  common: {
    retry: 'Tekrar dene',
    error: 'Hata',
    close: 'Kapat',
    delete: 'Sil',
    selectFile: 'Bir dosya seçin',
    uploadFailed: 'Yükleme başarısız',
    analysisFailed: 'Analiz başarısız',
    exportFailed: 'Dışa aktarma başarısız',
    loadFailed: 'Yüklenemedi',
    selectTwoVersions: 'Bir kanun ve her iki sürümü seçin',
    selectTwoDifferent: 'İki farklı sürüm seçin',
  },
};

export default tr;
